<template>
    <div class="multiple-popup-wrap scroll-tracker" :style="{ width: width + 'px', height: height + 'px' }">
        <ul class="option-list-content scroll-tracker" v-if="options.length">
            <li
                class="option-list-item"
                v-for="menu in menuItems"
                :class="{ 'option-selected': getItemStatus(menu) }"
                :key="menu.id"
                @click.stop="clickHandler(menu)"
            >
                <span>{{ menu.label }}</span>
                <Icon class="option-right-icon" :width="12" :height="9" bgPosition="-385px -49px" v-if="getItemStatus(menu)" />
            </li>
        </ul>
        <span class="option-tip" v-else>{{ noDataTip }}</span>
    </div>
</template>

<script>
import Icon from "@/views/zhiji/bComponents/icons/Icon";

export default {
    name: "MultiPopupMenu",
    props: ["width", "height", "options", "current", "isShowIcon", "checkStatus"],
    components: {
        Icon
    },
    data() {
        return {
            curValue: this.current,
            menuItems: []
        };
    },
    computed: {
        noDataTip() {
            return this.$t("zhiji.common.noData");
        }
    },
    mounted() {
        this.setMenuItems(this.options);
    },
    watch: {
        current() {
            this.curValue = this.current;
        },
        options(newVal) {
            this.setMenuItems(newVal);
        },
        checkStatus(newVal) {
            switch (newVal) {
                case "selectAll":
                    this.selectAll();
                    break;
                case "unSelectAll":
                    this.unSelectAll();
                    break;
                default:
                    break;
            }
        }
    },
    methods: {
        clickHandler(menu) {
            if (this.curValue.indexOf(menu.value) < 0) {
                this.curValue.push(menu.value);
            } else {
                // 如果已选中，再次选择时取消选中
                this.curValue.splice(
                    this.curValue.findIndex(item => item == menu.value),
                    1
                );
            }
            this.$emit("menuClick", {
                ids: this.curValue,
                item: menu
            });
        },
        getItemStatus(menu) {
            return this.current.some(item => {
                return item == menu.value;
            });
        },
        setMenuItems(menus) {
            this.menuItems.splice(0);
            this.menuItems.push(
                ...menus.map(function(menu) {
                    return {
                        label: menu.label,
                        value: menu.value
                    };
                })
            );
        },
        // 选中所有，只有在所有都处于未选中状态下调用
        selectAll() {
            const res = this.options.every((item) => this.curValue.indexOf(item.value) === -1);
            if (res) {
                this.options.forEach((item) => this.curValue.push(item.value));
            }
            this.options.forEach((menu) => {
                this.$emit("menuClick", {
                    ids: this.curValue,
                    item: menu,
                });
            });
        },
        // 取消所有选中
        unSelectAll() {
            this.options.forEach((item) => {
                this.curValue.splice(this.curValue.findIndex((val) => val === item.value), 1);
            });
            this.options.forEach((menu) => {
                this.$emit("menuClick", {
                    ids: this.curValue,
                    item: menu,
                });
            });
        }
    }
};
</script>

<style lang="less" scoped>
.multiple-popup-wrap {
    max-height: 320px;
    margin-top: 5px;
    background: #fff;
    border-radius: 4px;
    z-index: 1;
    box-shadow: 0 0 8px 0 rgba(90, 98, 111, 0.25);
    display: flex;
    justify-content: center;
    align-items: center;
    overflow-y: auto;
    width: calc(100% - 32px);
    margin: 0 auto;

    .option-list-content {
        flex: 1;
        max-height: 320px;
        overflow: auto;
        padding: 0;
        font-size: 12px;
    }
    .option-tip {
        color: #9e9e9e;
    }
    .option-list-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;
        padding: 8px 8px;
        word-break: break-all;
        word-wrap: break-word;
        cursor: pointer;

        &:hover {
            background: rgba(217, 235, 246, 0.7);
            color: #2ec2ff;
        }

        .option-right-icon {
            margin-left: 2px;
        }
    }

    .option-selected {
        background: rgba(217, 235, 246, 0.7);
        color: #2ec2ff;
    }
}
</style>
